import { useState } from 'react';
import { FormData } from '../components/onboarding/types';

const initialFormData: FormData = {
  fullName: '',
  email: '',
  password: '',
  phoneNumber: '',
  address: '',
  city: '',
  state: '',
  zipCode: '',
  bedrooms: '',
  bathrooms: '',
  squareFootage: '',
  yearBuilt: '',
  purchaseDate: '',
  interests: [],
  currentServices: [],
  desiredServices: [],
  acceptedTerms: false
};

export const useOnboardingForm = () => {
  const [formData, setFormData] = useState<FormData>(initialFormData);

  const updateField = <K extends keyof FormData>(field: K, value: FormData[K]) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const updateFields = (updates: Partial<FormData>) => {
    setFormData(prev => ({ ...prev, ...updates }));
  };

  const handleServiceToggle = (service: string, type: 'current' | 'desired') => {
    const field = type === 'current' ? 'currentServices' : 'desiredServices';
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].includes(service)
        ? prev[field].filter(s => s !== service)
        : [...prev[field], service]
    }));
  };

  const handleInterestToggle = (interest: string) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(interest)
        ? prev.interests.filter(i => i !== interest)
        : [...prev.interests, interest]
    }));
  };

  const resetForm = () => {
    setFormData(initialFormData);
  };

  return {
    formData,
    setFormData,
    updateField,
    updateFields,
    handleServiceToggle,
    handleInterestToggle,
    resetForm
  };
};
